import { Avatar, SvgIconProps, useTheme } from "@mui/material"
import { ComponentType, ReactElement } from "react"

import AppTooltip from "../helper/appTooltip"
import { AppCard, AppCardHeader } from "../surfaces/appCard"

interface IKpiCircleIconProps {
    title: string
    value: string
    icon: ComponentType<SvgIconProps>
    color?: "primary" | "secondary"
    tooltip?: string
}

/**
 * KPI card showing a value, a title and avatar icon
 */
const KpiCircleIcon = ({
    title,
    value,
    icon,
    color = "primary",
    tooltip = "",
}: IKpiCircleIconProps): ReactElement => {
    const theme = useTheme()
    const iconDispatcher = { icon }
    return (
        <AppTooltip title={tooltip}>
            <AppCard>
                <AppCardHeader
                    sx={{ mb: 0 }}
                    avatar={
                        <Avatar
                            sx={{
                                background:
                                    theme.palette.mode === "dark"
                                        ? theme.palette.background
                                              .contentBackground
                                        : theme.palette[color].light,
                                width: "70px",
                                height: "70px",
                                mr: 1,
                            }}
                        >
                            <iconDispatcher.icon
                                fontSize="large"
                                color={color}
                            />
                        </Avatar>
                    }
                    title={title}
                    subheader={value}
                    titleTypographyProps={{
                        variant: "body2",
                        fontWeight: "500",
                        color: "text.secondary",
                    }}
                    subheaderTypographyProps={{
                        variant: "h4",
                        fontWeight: "500",
                        color: "text.primary",
                    }}
                />
            </AppCard>
        </AppTooltip>
    )
}

KpiCircleIcon.defaultProps = {
    color: "primary",
    tooltip: "",
}

export default KpiCircleIcon
